export const MARKET_PAGE_POLLING_INTERVAL = 5_000;
export const TRADE_PAGE_POLLING_INTERVAL = 5_000;
export const IP_POLLING_INTERVAL = 5_000;
export const PORTFOLIO_PAGE_POLLING_INTERVAL = 30_000;
export const POLLING_ORDER_BOOK = 15_000;
export const POLLING_USER_PENDING_WITHDRAWABLE = 15_000;
export const POLLING_USER_BALANCE = 30_000;
export const POLLING_GRAPH = 15_000;
export const POLLING_OPEN_ORDER_CREATE_TIME = 10_000;
export const POLLING_HISTORY_POLLING = 10 * 1000;
export const POLLING_HISTORY_POLLING_DELAY = 5 * 1000;
export const POLLING_BLOCK_NUMBER = 3_000;
export const MARKET_LIST_POLLING_INTERVAL = 10_000 * 30;
export const MARKET_INFO_POLLING_INTERVAL = 5_000;
